module.exports = __webpack_public_path__ + "static/media/7.7cdf4257.JPG";